"use client";

import { useContext, useEffect } from "react";
import { triggerViewItem } from "@/service/ecommerce/google-analytics/single-item";
import { ResourceContext } from "@/contexts/resource-context";

export const TriggerEcommerceViewComponent = ({
  name,
  id,
  price,
  promotionPrice,
  category,
}) => {
  const { logView } = useContext(ResourceContext);

  useEffect(() => {
    triggerViewItem(
      {
        name,
        id,
        price: parseFloat(price),
        promotionPrice: promotionPrice ? parseFloat(promotionPrice) : null,
        category: category ?? "package",
      },
      logView,
    );
  }, []);
  return <></>;
};
